import { render, staticRenderFns } from "./SalonOrderEdit.vue?vue&type=template&id=12c1363a&scoped=true&"
import script from "./SalonOrderEdit.vue?vue&type=script&lang=js&"
export * from "./SalonOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./SalonOrderEdit.vue?vue&type=style&index=0&id=12c1363a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1363a",
  null
  
)

export default component.exports